import axios from 'axios'
import Vue from 'vue'
const BACKEND_URL = process.env.BACKEND_URL + 'ticket/'

const ticket = new Vue({
    beforeCreate() {
        axios.defaults.withCredentials = true
    },
    methods: {
        getTicketInfo(ticket_id) {
            const url = BACKEND_URL + ticket_id
            return axios.get(url).then(response => response.data)
        },
        reopenTicket(ticketId, guildId) {
            const url = BACKEND_URL + 'reopen'
            return axios.post(url, { guildId: guildId, ticket_id: ticketId }).then(response => response.data)
        },
    },
})

export default {
    install: function(Vue) {
        Vue.prototype.$ticket = ticket
    },
}



// WEBPACK FOOTER //
// ./src/api/ticket.js